export default __webpack_public_path__ + "src/_images/Config_Icon.svg";